import { render } from "./ElectricWaterWastewater.vue?vue&type=template&id=0b66e576&scoped=true"
import script from "./ElectricWaterWastewater.vue?vue&type=script&lang=js"
export * from "./ElectricWaterWastewater.vue?vue&type=script&lang=js"

import "./ElectricWaterWastewater.vue?vue&type=style&index=0&id=0b66e576&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b66e576"]])

export default __exports__